var exports = {
  "nM": "x43aef4ae--eb3701--row",
  "Qy": "x43aef4ae--eb3701--title-col",
  "dJ": "x43aef4ae--eb3701--sum-col",
  "Gd": "x43aef4ae--eb3701--payment-col",
  "Dp": "x43aef4ae--eb3701--image-and-title",
  "VG": "x43aef4ae--eb3701--title-block",
  "mx": "x43aef4ae--eb3701--image-block",
  "Qu": "x43aef4ae--eb3701--black-friday-badge",
  "XJ": "x43aef4ae--eb3701--title-column-right",
  "OM": "x43aef4ae--eb3701--promo-name",
};

module.exports = exports;
